export const SET_BACKEND_ERROR = 'SET_BACKEND_ERROR'
export const SET_BACKEND_VALIDATION_ERROR = 'SET_BACKEND_VALIDATION_ERROR'
export const SET_BACKEND_FILE_ERROR = 'SET_BACKEND_FILE_ERROR'
